export const API_ROUTE_PLEDGES = '/accounts/:accountId/pledges',
  API_ROUTE_PLEDGES_INIT = '/accounts/:accountId/pledges/init',
  API_ROUTE_PLEDGES_LEGAL_ENTITY_CHOICES = '/accounts/:accountId/pledges/legal-entity-choices',
  API_ROUTE_PLEDGE = '/accounts/:accountId/pledges/:pledgeId',
  Api_ROUTE_PLEDGE_OPTIONS = '/ref/pledge/options';
